module.exports = __webpack_public_path__ + "static/card3-87d1ce3bcb491c7bc082cd1e8fed5c88.png";